export default __webpack_public_path__ + "static/media/cloud.c0bcb31c.svg";